<section class="sliding-panel-wrapper" [ngStyle]="slidingPanelWrapperStyle">
  <ul class="sliding-panel-inner" #slidingPanel>
    <li *ngFor="let item of items;" class="sliding-panel-item-element">
      <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
    </li>
  </ul>
</section>
